import { createHook, createStore } from 'react-sweet-state';
const defaultNavigationState = {
  contextSpaPaths: [],
  contextEntryPoint: null
};
const defaultClientConfigState = {
  cloudId: null,
  stargateRoot: '',
  env: undefined
};
const defaultTeamsProductConfigState = {
  appName: null,
  productName: null,
  isJiraAvailable: false
};
const defaultState = {
  ...defaultNavigationState,
  ...defaultClientConfigState,
  ...defaultTeamsProductConfigState,
  docTitle: {}
};
const actions = {
  setNavigationConfig: navigationConfig => ({
    setState
  }) => {
    setState({
      ...navigationConfig
    });
  },
  setClientConfig: clientConfig => ({
    setState
  }) => {
    setState({
      ...clientConfig
    });
  },
  setTeamsProductConfig: teamsProductConfig => ({
    setState
  }) => {
    setState({
      ...teamsProductConfig
    });
  },
  // Set all config at once
  setAppConfig: appConfig => ({
    setState
  }) => {
    setState({
      ...appConfig
    });
  }
};
const AppConfigStore = createStore({
  initialState: defaultState,
  actions
});
export const useAppConfigStore = createHook(AppConfigStore);
const useAppConfigActions = createHook(AppConfigStore, {
  selector: null
});
export const useAppConfigStoreState = () => useAppConfigStore()[0];
export const useSetTeamsConfigActions = () => {
  return useAppConfigActions()[1];
};
export const useAppName = () => useAppConfigStoreState().appName;
export const useNavigationState = () => {
  const {
    contextSpaPaths,
    contextEntryPoint
  } = useAppConfigStoreState();
  return {
    contextSpaPaths,
    contextEntryPoint
  };
};